import React from "react";
import styles from "./index.module.scss";
import clsx from "clsx";
interface FormatTagsProps {
  className?: string;
  tags: string[];
}

export default function FormatTags(props: FormatTagsProps) {
  const { className, tags } = props;
  return (
    <div className={clsx(styles.wrapper, className)}>
      {tags.map((tag, index) => {
        return (
          <span key={index} className={styles["tag-item"]}>
            {tag}
          </span>
        );
      })}
    </div>
  );
}
